import React, { useContext, useCallback } from 'react'
import { useSelector } from 'react-redux';


export const Seller=({renderForm})=>{

  const dataSource = useSelector((state) => state.Actor.seller)

  
  const boxNumber = {name:"3/24", eoriNo:"3/25"}


  return renderForm
  ? renderForm({
      actorType: 'seller',
     boxNumber:{boxNumber},
      dataSource: dataSource,
      actorName:"Seller Name",
      displayContactInfo:true

    })
  : null
}